import { Link } from "react-router-dom";
import { Heart, Mail, Github, ShieldCheck } from "lucide-react";

const FOOTER_LINKS = [
  { label: "How it works", to: "/how-it-works" },
  { label: "Safety", to: "/safety" },
  { label: "FAQ", to: "/faq" },
  { label: "About", to: "/about" },
  { label: "Privacy", to: "/privacy" },
  { label: "Terms", to: "/terms" },
  { label: "Contact", to: "/contact" },
];

/**
 * Footer used on every public marketing page. Lifts orphan pages onto
 * the internal-link graph so Google + AI crawlers find them on every hit.
 */
export default function Footer() {
  return (
    <footer className="mt-20 pt-10 pb-12 border-t border-pink-100 bg-white/50" data-testid="site-footer">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-3 gap-8">
          <div>
            <Link to="/" className="inline-flex items-center gap-2" data-testid="footer-logo">
              <div className="w-9 h-9 rounded-xl bg-gradient-to-br from-pink-500 to-orange-400 grid place-items-center text-white font-display font-bold">D</div>
              <span className="font-display font-bold text-slate-900 text-lg">DoppelCrush</span>
            </Link>
            <p className="mt-3 text-sm font-body text-slate-600 max-w-xs">
              A playful selfie-based dating and social discovery app. Find your Doppel. Flirt with chaos.
            </p>
          </div>

          <nav aria-label="Footer navigation" className="md:col-span-1">
            <div className="text-xs font-display font-bold uppercase tracking-widest text-slate-500 mb-3">Explore</div>
            <ul className="space-y-2 text-sm font-body">
              {FOOTER_LINKS.map((l) => (
                <li key={l.to}>
                  <Link to={l.to} className="text-slate-700 hover:text-pink-600" data-testid={`footer-link-${l.to.replace(/\//g, "")}`}>
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          <div>
            <div className="text-xs font-display font-bold uppercase tracking-widest text-slate-500 mb-3">Get in touch</div>
            <ul className="space-y-2 text-sm font-body text-slate-700">
              <li className="inline-flex items-center gap-2">
                <Mail className="w-4 h-4 text-pink-600" />
                <a href="mailto:hello@doppelcrush.com" className="hover:text-pink-600">hello@doppelcrush.com</a>
              </li>
              <li className="inline-flex items-center gap-2">
                <ShieldCheck className="w-4 h-4 text-emerald-600" />
                <Link to="/safety" className="hover:text-pink-600">Safety &amp; privacy</Link>
              </li>
              <li className="inline-flex items-center gap-2">
                <Github className="w-4 h-4 text-slate-700" />
                <a href="https://github.com/" target="_blank" rel="noreferrer" className="hover:text-pink-600">Open updates</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs font-body text-slate-500">
          <div className="inline-flex items-center gap-1.5">
            Made with <Heart className="w-3.5 h-3.5 text-pink-500 fill-pink-500" /> by DoppelCrush · 18+ only
          </div>
          <div>© {new Date().getFullYear()} DoppelCrush</div>
        </div>
      </div>
    </footer>
  );
}
